module.exports = __webpack_public_path__ + "img/logo-atlassian.75c61dd3.png";